import ReduxProtectedPageTop from './redux-protected-page-top';

export default ReduxProtectedPageTop;